<sepidz-review [showAllDays]="showAllDays" [hasIncludeTime]="true" class="review">
  <div review-filters class="filters">
    <div>
      <div class="deposit-date-filter">
        <span>{{ "ClientApp.FrontOffice.Review.SalesReview.FilterRegistrationDate" | translate }}</span>
        <ssg-swichbox (valueChange)="applyDepositDateFilter()" [check]="filterByDepositCreatedDate">{{
          "ClientApp.FrontOffice.Review.SalesReview.FilterRegistrationDate" | translate
        }}</ssg-swichbox>
      </div>
      <div class="cardbody">
        <sepidz-static-select-review
          valueType="boolean"
          [form]="formGroup"
          [title]="'ClientApp.FrontOffice.Review.SalesReview.IncludeCancelled' | translate"
          name="IncludeCancelled"
          key="IncludeCancelled"
          [items]="[{ Name: 'ClientApp.FrontOffice.Review.SalesReview.IncludeCancelled' | translate, Value: true }]">
        </sepidz-static-select-review>
      </div>
    </div>
    <div class="listbox">
      <div class="titleheader" *ngIf="isMultiBranch">
        <div class="title" (click)="setSelectedFilter('Branch')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.Branch" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Branch'"></i>
        </div>
        <div *ngIf="selected === 'Branch'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.Branch' | translate"
            [form]="formGroup"
            name="Branch"
            key="BranchIds"
            apiName="Branch/ReadLookUp">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('User')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.User" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'User'"></i>
        </div>
        <div *ngIf="selected === 'User'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.User' | translate"
            [form]="formGroup"
            textFieldName="DisplayName"
            name="UserList"
            key="UserListIds"
            apiName="Authorization/GetUserList">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Factor')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.InvoiceStatus" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Factor'"></i>
        </div>
        <div *ngIf="selected === 'Factor'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.InvoiceStatus' | translate"
            [form]="formGroup"
            name="InvoiceStatus"
            key="InvoiceStatusIds"
            apiName="Lookup"
            systemName="SALE"
            category="InvoiceStatus">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('MealTime')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.MealTime" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'MealTime'"></i>
        </div>
        <div *ngIf="selected === 'MealTime'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.MealTime' | translate"
            [form]="formGroup"
            name="MealTime"
            key="MealTime"
            textFieldName="Title"
            [items]="MealTimeDataList">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('DeliveryType')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.DeliveryType" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'DeliveryType'"></i>
        </div>
        <div *ngIf="selected === 'DeliveryType'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.DeliveryType' | translate"
            [form]="formGroup"
            name="DeliveryType"
            key="DeliveryType"
            textFieldName="Title"
            [items]="DeliveryTypeDataList">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('ClearType')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.ClearType" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'ClearType'"></i>
        </div>
        <div *ngIf="selected === 'ClearType'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.ClearType' | translate"
            [form]="formGroup"
            name="ClearType"
            key="ClearType"
            textFieldName="Title"
            [items]="ClearTypeDataList">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Cook')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.Cook" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Cook'"></i>
        </div>
        <div *ngIf="selected === 'Cook'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.Cook' | translate"
            [form]="formGroup"
            name="Cook"
            key="Cook"
            textFieldName="DisplayName"
            apiName="Personnel/GetCooks">
          </sepidz-remote-select-review>
        </div>
      </div>
      <div class="titleheader">
        <div class="title" (click)="setSelectedFilter('Driver')">
          <span class="name">{{ "ClientApp.FrontOffice.Review.SalesReview.Driver" | translate }}</span>
          <i class="icon-chevron-right chevronicon" [class.icon-chevron-up]="selected === 'Driver'"></i>
        </div>
        <div *ngIf="selected === 'Driver'" class="selectitem scale-up-ver-top">
          <sepidz-remote-select-review
            [title]="'ClientApp.FrontOffice.Review.SalesReview.Delivery' | translate"
            [form]="formGroup"
            name="Delivery"
            key="Delivery"
            textFieldName="DisplayName"
            apiName="Personnel/GetDriverPersonnel">
          </sepidz-remote-select-review>
        </div>
      </div>
    </div>
  </div>
  <div review-content>
    <ssg-tabset class="tabset" (tabChange)="selectTab($event)" isTabsetRouter="undifined">
      <ssg-tab
        *ngIf="isMultiBranch && BranchSaleComparisonSummary"
        class="review-tab"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.BranchSaleComparison' | translate">
        <section class="sale-box" *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.BranchSaleComparison' | translate)">
          <div class="grid-box" [class.full-grid]="hideChart" [ngStyle]="isDepositReview ? { height: '80%' } : undefined">
            <div>
              <span class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.BranchSaleComparisonTitle" | translate }}</span>
            </div>
            <sepidz-grid-review
              *ngIf="GetBranchSaleComparisonColumns && GetBranchSaleComparisonColumns.length > 0"
              name="BranchSaleComparison"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.BranchSaleComparison' | translate"
              [apiName]="'OrderReview/BranchSaleComparison'"
              areaName="RestaurantSale"
              [groupable]="false"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="GetBranchSaleComparisonColumns"
              [filtering]="false"
              pathPreFix="SALE"
              displayNameColumn="BranchTitle"
              key="BranchId"
              aggregatesColumnName="BranchTitle,BranchId,TotalRounding, PackingPrice,TotalTip,TotalShippingCost,TotalCredit,TotalDebit,UsedCredit,TotalTax,TotalService,InvoiceCount,PayableTotal">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>
      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:OrderReview/DepositSale', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.Sale' | translate">
        <section class="sale-box" *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.Sale' | translate)">
          <div fxLayout="row wrap" fxLayoutGap="8px">
            <div fxFlex class="kpi-container">
              <sepidz-kpi-review name="AllDepositSummaryKpi" [bundles]="kpiBundlesDeposit" apiName="OrderReview/DepositSummaryKpi">
              </sepidz-kpi-review>
            </div>
          </div>
          <div class="grid-box" [class.full-grid]="hideChart" [ngStyle]="isDepositReview ? { height: '80%' } : undefined">
            <div>
              <span class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.SaleMethodSalesSummaryList" | translate }}</span>
            </div>
            <sepidz-grid-review
              *ngIf="GetSaleMethodSummaryColumns && GetSaleMethodSummaryColumns.length > 0"
              name="SaleMethodSalesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.SaleMethodSalesSummaryList' | translate"
              apiName="OrderReview/SaleMethodDepositSummaryList"
              areaName="RestaurantSale"
              [groupable]="false"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="GetSaleMethodSummaryColumns"
              [filtering]="false"
              pathPreFix="SALE"
              displayNameColumn="SaleMethodTitle"
              key="SaleMethodIds"
              aggregatesColumnName="TotalRounding, PackingPrice,TotalTip,TotalShippingCost,TotalCredit,TotalDebit,UsedCredit,TotalTax,TotalService,InvoiceCount,PayableTotal">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>
      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:OrderReview/DepositSalesSummaryList', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.DepositSales' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.DepositSales' | translate)">
          <div class="mt-xs ml-xs h-100">
            <div class="title-tab">
              {{ "ClientApp.FrontOffice.Review.SalesReview.DepositSalesSummaryList" | translate }}
            </div>
            <sepidz-grid-review
              *ngIf="depositSalesSummaryColumns && depositSalesSummaryColumns.length > 0"
              name="DepositSalesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.DepositSalesSummaryList' | translate"
              apiName="OrderReview/DepositSalesSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterableDeposit"
              [columns]="depositSalesSummaryColumns"
              [filtering]="false"
              key="InvoiceIds"
              defaultSortKey="InvoiceCode"
              pathPreFix="SALE"
              displayNameColumn="CustomerName"
              aggregatesColumnName="PayableTotal,ServicesAmount,Remain,DepositAmount,ShippingCost">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>

      <ssg-tab
        *hasPermission="['RestaurantSale:OrderReview/InvoiceItemDepositSummaryList', 'Same']"
        class="review-tab"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.DepositDetail' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.DepositDetail' | translate)">
          <div class="mt-xs ml-xs h-100">
            <div class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.DepositDetail" | translate }}</div>
            <sepidz-grid-review
              *ngIf="invoiceItemSummaryColumns && invoiceItemSummaryColumns.length > 0"
              name="InvoiceItemDepositSummaryList"
              key="FactorDetails"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.DepositDetail' | translate"
              apiName="OrderReview/InvoiceItemDepositSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              displayNameColumn="ItemNumber"
              pathPreFix="SALE"
              [columns]="invoiceItemSummaryColumns"
              aggregatesColumnName="Quantity,UnitPrice,TotalTax,TotalService,TotalDiscount,TotalPriceInclServiceInclTax,TotalPrice"
              [filtering]="false">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>

      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:OrderReview/DepositItem', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.Item' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.Item' | translate)">
          <div class="mt-xs ml-xs" [class.h-100]="isDepositReview">
            <div class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.ItemSalesSummaryList" | translate }}</div>
            <sepidz-grid-review
              *ngIf="GetItemSummaryColumns && GetItemSummaryColumns.length > 0"
              name="ItemSalesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.ItemSalesSummaryList' | translate"
              apiName="OrderReview/ItemDepositSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="GetItemSummaryColumns"
              [filtering]="false"
              key="ItemIds"
              defaultSortKey="Number"
              pathPreFix="SALE"
              displayNameColumn="ItemTitle"
              aggregatesColumnName="TotalPriceInclServiceInclTax,TotalDiscount,TotalTax,TotalService,InvoiceCount,TotalPrice,UnitPrice">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>

      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:OrderReview/PersonnelServicesSummaryList', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.PersonnelServices' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.PersonnelServices' | translate)">
          <div class="mt-xs ml-xs h-100">
            <div class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.PersonnelServices" | translate }}</div>
            <sepidz-grid-review
              *ngIf="personnelServicesSummaryColumns && personnelServicesSummaryColumns.length > 0"
              name="PersonnelServicesSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.PersonnelServicesSummaryList' | translate"
              apiName="OrderReview/PersonnelServicesSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="personnelServicesSummaryColumns"
              [filtering]="false"
              defaultSortKey="PersonnelName"
              pathPreFix="SALE"
              aggregatesColumnName="Amount">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>
      <ssg-tab
        class="review-tab"
        *hasPermission="['RestaurantSale:OrderReview/DepositSummaryList', 'Same']"
        [tabTitle]="'ClientApp.FrontOffice.Review.SalesReview.Deposit' | translate">
        <section *ngIf="isActveTab('ClientApp.FrontOffice.Review.SalesReview.Deposit' | translate)">
          <div class="mt-xs ml-xs h-100">
            <div class="title-tab">{{ "ClientApp.FrontOffice.Review.SalesReview.DepositSummaryList" | translate }}</div>
            <sepidz-grid-review
              *ngIf="depositSummaryColumns && depositSummaryColumns.length > 0"
              name="DepositSummaryList"
              [title]="'ClientApp.FrontOffice.Review.SalesReview.DepositSummaryList' | translate"
              apiName="OrderReview/DepositSummaryList"
              areaName="RestaurantSale"
              [unSortableFilterable]="unSortableFilterable"
              [columns]="depositSummaryColumns"
              [filtering]="false"
              defaultSortKey="InvoiceCode"
              pathPreFix="SALE"
              aggregatesColumnName="Amount">
            </sepidz-grid-review>
          </div>
        </section>
      </ssg-tab>
    </ssg-tabset>
  </div>
</sepidz-review>
